import { z } from 'zod';
import { AwsRegionRegex } from './aws-patterns.constants';

export const AwsRegionSchema = z.string().trim().regex(AwsRegionRegex, {
  error: 'AWS region must match a value such as us-east-1 or eu-west-1',
});
